var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newSubCalcFieldDefinition(data) {
    var instance = {
        __type: "SubCalcFieldDefinition:#DecisionsFramework.Design.Report.SubcalcFields",
        FieldName: null,
        DataSource: null,
        OutputName: null,
        CalculationType: 0 /* CalculationType.Count */,
        TypeOfCalc: 0 /* CalculationType.Count */,
        Format: null,
        IsFromRowDimension: false,
        Color: null,
        ShowValuesAsPercentageOfTotal: false
    };
    return __assign(__assign({}, instance), data);
}
export function isSubCalcFieldDefinition(object) {
    return object.__type === "SubCalcFieldDefinition:#DecisionsFramework.Design.Report.SubcalcFields";
}
